(function ($) {
	'use strict';
	$.fn.isInViewport = function ($topPadding = 0) {
		var elementTop = $(this).offset().top;
		var elementBottom = elementTop + $(this).outerHeight();

		var viewportTop = $(window).scrollTop() + $topPadding;
		var viewportBottom = viewportTop + $(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	};
})(jQuery);